export const BASE_API_URL = 'https://vue-moire.skillbox.cc';

export const config = {
    shopPhone: "+7 916 123 4567",
    shopEmail: "boangri@mail.ru",
};
